import { render } from "./UserCompanies.vue?vue&type=template&id=0c884867&scoped=true"
import script from "./UserCompanies.vue?vue&type=script&lang=js"
export * from "./UserCompanies.vue?vue&type=script&lang=js"

import "./UserCompanies.vue?vue&type=style&index=0&id=0c884867&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c884867"]])

export default __exports__